import { api } from 'common';

import { SchedulingFormFields } from './FormFields';
import { schedulingDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const schedulingConfig: BlockConfigProps<api.FlowDefinition.SchedulingBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'scheduling',
  defaultConfig: {
    practiceIds: [],
    providerUserIds: [],
    appointmentTypes: [],
  },
  configFields: {
    schema: api.FlowDefinition.SchedulingBlockConfigSchema,
    FormFields: SchedulingFormFields,
  },
  documentationMarkdown: schedulingDocumentationMarkdown,
};
